import { i18n } from './i18n';
import { t } from '@lingui/macro';

export const useChildrenError = error => {
  switch (error) {
    case 'quantity':
      return {
        text: i18n._(t`Указано менее трёх детей`)
      };
    default:
      return { title: '', text: '' };
  }
};
